import Fetch from "@/utils/Fetch"
import filtersToSearchParams from "@/utils/filtersToSearchParams";

export default {
	namespaced: true,
	state() {
		return {
			notificationList: [],
            pagination: {
                total: 0,
                offset: 0,
                limit: 10,
            }
		}
	},
	mutations: {
        setNotificationList(state, value) {
            state.notificationList = value
        },
        setPagination(state, paginationData) {
            if (!paginationData) return;
            Object.assign(state.pagination, {...paginationData})
        },
	},
	actions: {
        async requestNotifications({commit, dispatch, state}) {
            commit('startLoading', 'requestNotifications', {root: true})

            const {offset, limit} = state.pagination;
            const search = filtersToSearchParams(state.filter, offset, limit);

            const response = await Fetch(`notifications/${search}`, {})
            if (response.success) {
                commit('setNotificationList', response.data.items)
                commit('setPagination', {total: Number(response.data?.countTotal)})
            } else {
                dispatch('showError', response.message, {root: true})
            }

            commit('stopLoading', 'requestNotifications', {root: true})

            return {
                ...response.data
            }
        },
        updatePagination({commit, dispatch}, paginationData) {
            commit('setPagination', paginationData);
            dispatch('requestNotifications', false);
        },

        updateFilter({commit, dispatch}, filterData) {
            commit('setFilter', filterData);
            dispatch('requestNotifications', false);
        }

	},

	getters: {
        getNotificationList: state => state.notificationList,
        getNotificationPagination: state => state.pagination,
        getNotificationFilter: state => state.filter
	}
}

